import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {throwError} from 'rxjs';

import {Config} from './app.config';
import {BehaviorSubject} from "rxjs";
import 'devextreme/data/odata/store';
import jwt_decode from 'jwt-decode';

import {HeaderEnum, RespuestaEstatusEnum} from './Enumeraciones/Enumeraciones.enum';
import {TranslateService} from '@ngx-translate/core';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {SistemaService} from './Servicios/Sistema.Service';

export type InteralStateType =
    {
        [key: string]: any
    };

export class Respuesta {
    message: string = "";
    data: any = null;
    status: number = 0;
}

declare let require: any;

@Injectable()
export class AppService {
    public cerrarSesion: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public iniciarConteoInactividad: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public sesionFinalizada: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    CryptoJS = require("crypto-js");

    public headerAutentificacion: string;
    public headerJWE: string;
    public headerNoSpinner: string;
    public headerContentType: string;
    public headerLenguaje: string;

    constructor(private http: HttpClient, private config: Config, private translate: TranslateService, private mensajeService: MensajeService, private sistemaService: SistemaService) {
        this.config.Configuracion.urlServicios = this.base64ToString(this.config.Configuracion.urlServicios);
        this.config.Configuracion.secret = this.base64ToString(this.config.Configuracion.secret);

        this.headerAutentificacion = "Authorization";
        this.headerJWE = "SAP-ENC";
        this.headerNoSpinner = "ignoreLoadingBar";
        this.headerContentType = "Content-Type";
        this.headerLenguaje = "Lenguaje";
    }

    Get(url: string, noHeaders: Array<HeaderEnum> = []): Promise<Respuesta> {
        return new Promise((resolve, reject) => {
            let httpOptions = {headers: this.SetHeader(noHeaders), observe: 'response' as 'response'};

            this.http.get(this.config.Configuracion.urlServicios + url, httpOptions).subscribe(
                (response: HttpResponse<any>) => {
                    let message = response.body['message'];
                    let token = response.body['token'];
                    switch (response.status) {
                        case RespuestaEstatusEnum.Success:
                            let de_jwt: any = this.DesencriptarDatos(token);
                            resolve({status: response.status, message: message, data: de_jwt})
                            break;
                        case RespuestaEstatusEnum.Parcial:
                            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(message));
                            reject({status: response.status})
                            break;
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status == RespuestaEstatusEnum.NoAutorizado) {
                        this.noAutorizado(url)
                        reject({status: error.status});
                    } else {
                        reject()
                        this.handleError(error)
                    }

                }
            )
        })
    }

    Post(url: string, datos: any, noHeaders: Array<HeaderEnum> = []): Promise<Respuesta> {
        return new Promise((resolve, reject) => {
            let httpOptions = {headers: this.SetHeader(noHeaders), observe: 'response' as 'response'};
            let cuerpo = {"token": this.EncriptarDatos(datos)};

            this.http.post(this.config.Configuracion.urlServicios + url, cuerpo, httpOptions).subscribe(
                (response: HttpResponse<any>) => {
                    let message = response.body['message'];
                    let token = response.body['token'];
                    switch (response.status) {
                        case RespuestaEstatusEnum.Success:
                            let de_jwt: any = this.DesencriptarDatos(token);
                            resolve({status: response.status, message: message, data: de_jwt})
                            break;
                        case RespuestaEstatusEnum.Parcial:
                            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(message));
                            reject({status: response.status})
                            break;
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status == RespuestaEstatusEnum.NoAutorizado) {
                        this.noAutorizado(url)
                        reject({status: error.status});
                    } else {
                        reject()
                        this.handleError(error)
                    }
                }
            )
        })
    }

    //Post para descargar un archivo por parametros 
    PostGetFile(url: string, datos: any, noHeaders: Array<HeaderEnum> = []): Promise<Respuesta> {
        return new Promise((resolve, reject) => {
            let httpOptions = {headers: this.SetHeader(noHeaders), observe: 'response' as 'response', responseType: 'arraybuffer' as 'arraybuffer'};
            let cuerpo = {"token": this.EncriptarDatos(datos)};

            this.http.post(this.config.Configuracion.urlServicios + url, cuerpo, httpOptions).subscribe(
                (response: HttpResponse<any>) => {
                    let respuesta: ArrayBuffer = response.body;
                    switch (response.status) {
                        case RespuestaEstatusEnum.Success:
                            let filetype: any = response.headers.get('content-type');
                            let filename: any = response.headers.get('x-file-name');
                            const blob = new Blob([respuesta], {type: filetype});
                            var a = document.createElement("a");
                            a.href = URL.createObjectURL(blob);
                            a.download = filename;
                            a.click();
                            resolve({status: response.status, message: '', data: respuesta})
                            break;
                        case RespuestaEstatusEnum.Parcial:
                            let message = String.fromCharCode.apply(null, Array.from<number>(new Uint8Array(respuesta)))
                            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(message));
                            reject({status: response.status})
                            break;
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status == RespuestaEstatusEnum.NoAutorizado) {
                        this.noAutorizado(url)
                        reject({status: error.status});
                    } else {
                        reject()
                        this.handleError(error)
                    }
                }
            )
        })
    }

    Put(url: string, datos: any, noHeaders: Array<HeaderEnum> = []): Promise<Respuesta> {
        return new Promise((resolve, reject) => {
            let httpOptions = {headers: this.SetHeader(noHeaders), observe: 'response' as 'response'};
            let cuerpo = {"token": this.EncriptarDatos(datos)};

            this.http.put(this.config.Configuracion.urlServicios + url, cuerpo, httpOptions).subscribe(
                (response: HttpResponse<any>) => {
                    let message = response.body['message'];
                    let token = response.body['token'];
                    switch (response.status) {
                        case RespuestaEstatusEnum.Success:
                            let de_jwt: any = this.DesencriptarDatos(token);
                            resolve({status: response.status, message: message, data: de_jwt})
                            break;
                        case RespuestaEstatusEnum.Parcial:
                            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(message));
                            reject({status: response.status})
                            break;
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status == RespuestaEstatusEnum.NoAutorizado) {
                        this.noAutorizado(url)
                        reject({status: error.status});
                    } else {
                        reject()
                        this.handleError(error)
                    }
                }
            )
        })
    }

    Delete(url: string, noHeaders: Array<HeaderEnum> = []): Promise<Respuesta> {
        return new Promise((resolve, reject) => {
            let httpOptions = {headers: this.SetHeader(noHeaders), observe: 'response' as 'response'};

            this.http.delete(this.config.Configuracion.urlServicios + url, httpOptions).subscribe(
                (response: HttpResponse<any>) => {
                    let message = response.body['message'];
                    //let token = response.body['token'];
                    switch (response.status) {
                        case RespuestaEstatusEnum.Success:
                            //let de_jwt: any = this.DesencriptarDatos(token);
                            resolve({status: response.status, message: message, data: {}})
                            break;
                        case RespuestaEstatusEnum.Parcial:
                            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(message));
                            reject({status: response.status})
                            break;
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status == RespuestaEstatusEnum.NoAutorizado) {
                        this.noAutorizado(url)
                        reject({status: error.status});
                    } else {
                        reject()
                        this.handleError(error)
                    }
                }
            )
        })
    }

    SetHeader(encabezados: Array<HeaderEnum>) {
        let headers = new HttpHeaders({});

        if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT) && this.sistemaService.datosInicialesCargados) {
            headers = headers.set(this.headerAutentificacion, localStorage.getItem(this.sistemaService.localStoreVariable.JWT) as string);
        }

        headers = headers.set('Content-Type', 'application/json');
        //headers = headers.set(this.headerLenguaje, this.translate.currentLang);

        encabezados.forEach(encabezado => {
            switch (encabezado) {
                case HeaderEnum.NoShowLoading:
                    headers = headers.set(this.headerNoSpinner, '');
                    break;

                case HeaderEnum.NoAutentificar:
                    headers = headers.delete(this.headerAutentificacion);
                    break;

                default:
                    break;
            }
        });

        return headers;
    }

    //-- Encriptar los datos de LandingPage
    EncriptarDatos(datos: any) {
        let header =
        {
            typ: "JWT",
            alg: "HS256"
        }

        let stringifiedHeader = this.CryptoJS.enc.Utf8.parse(JSON.stringify(header));
        let encodedHeader = this.base64url(stringifiedHeader);

        let stringifiedData = this.CryptoJS.enc.Utf8.parse(JSON.stringify(datos));
        let encodedData = this.base64url(stringifiedData);

        let token = encodedHeader + "." + encodedData;

        let signature = this.CryptoJS.HmacSHA256(token, this.config.Configuracion.secret);
        signature = this.base64url(signature);

        let jwt = token + "." + signature;
        return jwt;
    }

    base64url(source: any) {
        let encodedSource = this.CryptoJS.enc.Base64.stringify(source);

        encodedSource = encodedSource.replace(/=+$/, '');

        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');

        return encodedSource;
    }

    base64ToString(cadena: any) {
        var words = this.CryptoJS.enc.Base64.parse(cadena);
        var decode = this.CryptoJS.enc.Utf8.stringify(words)

        return decode;
    }

    DesencriptarDatos(respuesta: string) {
        var decode: any = jwt_decode(respuesta);

        if (this.EncriptarDatos(decode) == respuesta) {
            return JSON.parse(decode.data);
        }
        else {
            return "";
        }
    }

    noAutorizado(url: string) {
        this.cerrarSesion.next(url);
        this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant("No estas autorizado"));
        this.sistemaService.opcionesMenu = [];
    }

    handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant(errorMessage));
        return throwError(errorMessage);
    }
}
